import React from 'react';
import { string, number, oneOfType } from 'prop-types';

export default function HeaderItem({ label, value }) {
    return (
        <div className="details-item">
            <div className="details-item-label">
                {label}
            </div>
            <div className="details-item-value">
                {value || '-'}
            </div>
        </div>
    );
}

HeaderItem.propTypes = {
    label: string.isRequired,
    value: oneOfType([string, number]).isRequired
};
